import styled from 'styled-components';
import { getRotation } from 'styles/globalStyles';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 0;
  border-radius: ${props => props.theme.radii.pill};
  transition: ${props => props.theme.transition.main};

  & a {
    font-family: ${props => props.theme.fonts.body};
    font-size: 16px;
    font-weight: 600;
    color: ${props => props.theme.colors.textPrimary};
    transition: ${props => props.theme.transition.main};
  }

  &:hover a {
    color: ${props => props.theme.colors.secondary};
  }
`;

export const ArrowButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  outline: none;
  border: none;

  & svg {
    transform: ${getRotation};
    width: 11px;
    height: 11px;
    fill: transparent;
    stroke: ${props => props.theme.colors.textPrimary};
    transition: ${props => props.theme.transition.main};
  }
  &:hover svg {
    stroke: ${props => props.theme.colors.secondary};
    transform: rotate(270deg) scale(1.4);
  }
`;
